import { render, staticRenderFns } from "./ReportColumnValue.vue?vue&type=template&id=a404d1aa&"
import script from "./ReportColumnValue.vue?vue&type=script&lang=js&"
export * from "./ReportColumnValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports